import { Component, ElementRef, ViewChild } from '@angular/core';
import { WIZ_EVENT_TYPE, WIZ_PHYSIC_POSITION } from '@wizeoo/akm-core-lib';
import {
  FilterComponent,
  PopUpManager,
  WizBaseCollector,
  WizBasePopUp,
  WizCheckbox,
  WizDatasource,
  WizDropItemEvent,
  WizList,
  WizPopUp,
  WizVgroup,
  WizEventManager, WizEvent
} from '@wizeoo/akm-component-lib';
import { WidgetConfigurationObj, WidgetConfigurationItemObj } from '@wizeoo/akm-message-lib';
import { FIELD_KIND, FeiKeyDef, EM_ACTION } from '@wizeoo/akm-compute-lib';
import { cloneDeep } from 'lodash-es';

import { ALK_EVENT_TYPE, WIDGET_KIND } from '../../../../model/enums';
import { ViewData } from '../../../../model/view.data';
import { FreedataArgsVO } from '../../../../vo/core/freedataargs.vo';
import { FreedataValueVO } from  '../../../../vo/core/freedatavalue.vo';
import { FreeDataVO } from '../../../../vo/core/freedata.vo';
import { AlkEvent } from '../../../../framework/events/alk.event';
import { PivotField } from '../../../../manager/baselines/pivot-field.obj';
import { FreedataHeaderEditPop } from '../../freedatas/pops/freedata-header-edit.pop';
import { GridsterWidgetItem } from '../../../../vo/workingzone/gridster-widget-item';
import { IFreedataWidget } from '../../../../manager/widgets/i-widget';
import { gridsterItemEvent } from '../../form/generic/form-widget.gridster.component';
import { Model } from '../../../../model/model';
import { FreedataTimelineEditItemRenderer } from '../renderers/freedatatimeline-edit-item.renderer';
import { widgetHeaderVO } from '../../pivot/renderers/header/header-editext.pop';


@Component({
  // popUp d'édition du grid en mode flat : gestion des emplacements de champs et rendu
  selector: 'freedata-timeline-settings-pop',
  templateUrl: './freedata-timeline-settings.pop.html',
})
export class FreedataTimelineSettingsPop extends WizBasePopUp {
  // liste des champs et mesures disponibles
  @ViewChild('freeList', { read: WizList }) freeList: WizList;
  /** le composant de filtre principal */
  @ViewChild('mainFilter', { read: FilterComponent })
  mainFilter: FilterComponent;
  // zone globale des listes
  @ViewChild('vgDetailZone', { read: WizVgroup, static: false })
  vgDetailZone: WizVgroup;

  @ViewChild('lstRow', { read: WizList }) lstRow: WizList; // liste des champs en ligne
  @ViewChild('lstColumn', { read: WizList }) lstColumn: WizList; // liste des champs de mesure (dates & color)
  @ViewChild('lstFilter', { read: WizList }) lstFilter: WizList; // liste des champs de filtre
  
  @ViewChild('cbShowDeleteCol', { read: WizCheckbox }) cbShowDeleteCol: WizCheckbox; // cb d'affichage de la colonne delete
  @ViewChild('cbShowSelectCol', { read: WizCheckbox }) cbShowSelectCol: WizCheckbox; // cb d'affichage de la colonne select

  // dimensions demandées
  public static width: string = '1000px';
  public static height: string = 'calc(100% - 81px)';

  /** Renderer de la liste */
  public renderer: any = FreedataTimelineEditItemRenderer;

  public dataSource: WizDatasource<PivotField> = null; // DS des champs disponibles (au step)

  public measureDS: WizDatasource<PivotField> = new WizDatasource<PivotField>().setSelectionMode('none').build();
  public rowDS: WizDatasource<PivotField> = new WizDatasource<PivotField>().setSelectionMode('none').build();
  public filterDS: WizDatasource<PivotField> = new WizDatasource<PivotField>().setSelectionMode('none').build();

  public get widget(): IFreedataWidget {
    return this.datas;
  }

  public get model(): Model {
    return this.widget.model;
  }

  widgets: GridsterWidgetItem[] = [];


  protected context: WidgetConfigurationObj; // la configuration
  protected updateCallback: Function; // la callback pour retour et traitement dans le pivotComponent
  // protected pivot: IWidget = null; // passage du pivot pour transfert à la popUp de configuration des champs

  protected doSaveFlag: boolean = true; // marqueur de validation des modifs (false sur cancel)
  protected fieldPop: WizPopUp; // la popUp d'édition des champs
  public popUpMode: WIDGET_KIND = WIDGET_KIND.GRID; // le mode de cette pop, pour alimenter les PKD
  
  // Le freeData fake utilisé juste pour la configuration
  fakeFreeDataValue: FreedataValueVO;

  constructor(public elementRef: ElementRef) {
    super();
  }

  show(): void {

    this.context = cloneDeep(this.widget.context); 
    this.updateCallback = this.widget.backFromSettingsPop.bind(this.widget);


    // this.context = JSON.parse(JSON.stringify(this.datas[1]));
    // this.updateCallback = this.datas[2];
    // this.pivot = this.datas[3];

    const fd: FreeDataVO = this.model.freedataEngine.getFreeData(this.context.fdk.split(ViewData.CONTEXT_SEPARATOR)[0]);// todo gérer le level
    this.fakeFreeDataValue = this.model.freedataEngine.createFreeDataValue(fd, null);

    const filter = []; // alimentation du filtre de la DS principale

    this.mainFilter.configure(['code', 'labelOrDefaultLabel'], null, Array.from(filter)).build();

    const parts: string[] = this.context.fdk.split(ViewData.CONTEXT_SEPARATOR); // on split sur #
    const args: FreedataArgsVO[] = this.model.freedataEngine.getArgsFromFD(parts[0]);
    const fieldsMap: Map<string, FreedataArgsVO> = new Map(args.map(item => [item.code, item]));
  
    const dataDS: PivotField[] = [];
    args.forEach((fda: FreedataArgsVO) => {
      const wcio: WidgetConfigurationItemObj = this.model.widgetEngine.newWcio(this.context.fdk, 0);
      wcio.fdvf = fda.code;
      dataDS.push(new PivotField(this.widget, wcio, null, fda));
    });


    this.dataSource = new WizDatasource<PivotField>(dataDS)
    .setItemCodeField('code')
    .setSelectionMode('none')
    .setSortFields([{ property: 'order', way: 'asc', numeric: true }, { property: 'trsLabel', way: 'asc', numeric: false }])
    .setFilter(this.filterFunc.bind(this))
    .build();


    // alimentation des collections depuis le contexte
    const preMeasureArr: PivotField[] = [];
    const preRowArr:PivotField[] = [];
    const preFilterArr:PivotField[] = [];
    this.context.r.forEach((confItem: WidgetConfigurationItemObj) => {
      // utiliser code pour le FD, fdvf pour le champ
      const fake = this.dataSource.getItemByKey(confItem.fdvf);
      if (!!fake)  {
        const ff: PivotField = new PivotField(this.widget, confItem, null, fake.arg);
        ff.usedAsRow = true;
        ff.pinned = confItem.pin; // reprise des informations de pin
        preRowArr.push(ff);
      }
        
    });
  
    this.context.c.forEach((confItem: WidgetConfigurationItemObj) => {
      const fake = this.dataSource.getItemByKey(confItem.fdvf);
      if (!!fake)  {
        const ff: PivotField = new PivotField(this.widget, confItem, null, fake.arg);
        ff.usedAsColumn = true;
        preMeasureArr.push(ff);
      }

    });

    this.context.f.forEach((confItem: WidgetConfigurationItemObj) => {
      const fake = this.dataSource.getItemByKey(confItem.fdvf);
      if (!!fake)  {
        const ff: PivotField = new PivotField(this.widget, confItem, null, fake.arg);
        ff.usedAsFilter = true;
        preFilterArr.push(ff);
      }
    });

    this.measureDS.setSource(preMeasureArr);
    this.rowDS.setSource(preRowArr);
    this.filterDS.setSource(preFilterArr);


    this.widgets = [];
    if (this.context.ff) {
      this.context.ff.forEach(obj => {
        // console.log('ffsetting', obj, obj.subField);
        const matrix: FreedataArgsVO = fieldsMap.get(obj.fdvf); // va servir de matrice, c'est la structure
        
        if (!!matrix) {
          // mais on peut en faire plusieurs
          const result = new GridsterWidgetItem(obj, new PivotField(this.widget, obj, null, matrix));
          this.widgets.push(result);
        }
      });      
    }   
    this.feedDatasources();
    this.addListeners();
  }

  /** icone de suppression globale */
  public onDeleteClick(): void {
    this.widgets = [];
  }

  /** sur séquence de démarrage, alimentation des listes avec leurs DS */
  public feedDatasources(): void {
    this.lstColumn.wizDataProvider = this.measureDS;
    this.lstColumn.dropControlFunction = this.measureDropControl.bind(this);

    this.lstFilter.wizDataProvider = this.filterDS;
    this.lstFilter.dropControlFunction = this.filterDropControl.bind(this);


    // aucun contrôle sur rows et datas
    this.lstRow.wizDataProvider = this.rowDS;

    // ajout du transformer sur les zones cibles
    this.lstColumn.dropTransformFunction = this.fakeToFF.bind(this);
    this.lstRow.dropTransformFunction = this.fakeToFF.bind(this);
    this.lstFilter.dropTransformFunction = this.fakeToFF.bind(this);

    this.cbShowDeleteCol.wizChecked = !!this.context.shd;
    this.cbShowSelectCol.wizChecked = !!this.context.shs;
  }

  /** mise en place des écouteurs */
  public addListeners(): void {
    WizEventManager.addListener(this, this.mainFilter, WIZ_EVENT_TYPE.FILTER, this.doFilter); // ecouteur sur le filtre de la DS principale
    // écouteur global change pour modelUpdate
    WizEventManager.addListener(this, this.vgDetailZone, WIZ_EVENT_TYPE.DRAG_DROPPED, this.updateModel);
    WizEventManager.addListener(this, this.vgDetailZone, WIZ_EVENT_TYPE.DRAG_MOVED, this.updateModel);
    WizEventManager.addListener(this, this.vgDetailZone, WIZ_EVENT_TYPE.DELETE, this.updateModel);

    WizEventManager.addListener(this, this.elementRef, ALK_EVENT_TYPE.PIVOT_CONFIGURE_FIELD, this.showConfPop); // demande de conf d'un champ
  }

  /** validation du contenu */
  public doValid(): void {
    this.hide();
  }

  /** annulation des modifs */
  public doCancel(): void {
    this.doSaveFlag = false;
    this.hide();
  }

  /** modification du context pour retour sur la base des params */
  public updateContext(): void {
    // mémorisation du contexte de filtre
    // const measureMap: Map<string, WidgetConfigurationItemObj> = new Map<string, WidgetConfigurationItemObj>();
    // if (this.context.c) {
    //   this.context.c.forEach((wcio: WidgetConfigurationItemObj) => {
    //     measureMap.set(wcio.fdvf, wcio);
    //   });
    // }

    this.context.r = [];
    this.context.c = [];
    this.context.f = [];

    let idx: number = 1; // positions
    let confItem: WidgetConfigurationItemObj;
    this.rowDS.getSource().forEach((item: PivotField) => { // rows

      confItem = this.model.widgetEngine.newWcio(this.context.fdk, idx);
      confItem.pin = item.pinned;
      confItem.fdvf = item.code;
      confItem.pmdexParams = item.pmdexParams;
      this.model.widgetEngine.wcioColParams(confItem, item.colRezisable, item.colMinSize, item.colSize); // taille de col
      this.model.widgetEngine.wcioStyleParams(confItem, item.format, item.style, item.headerStyle); // format & style
      

      this.context.r.push(confItem);
      idx++;
    });

    this.measureDS.getSource().forEach((item: PivotField) => { // mesures
      
      confItem = this.model.widgetEngine.newWcio(this.context.fdk, idx);
      // console.log('c item', item.code, item.label, item.format);
      confItem.fdvf = item.code;
      confItem.lbl = item.label;
      confItem.pmdexParams = item.pmdexParams;
      this.model.widgetEngine.wcioStyleParams(confItem,null, null, item.headerStyle); // format & style
      
      this.context.c.push(confItem);
      idx++;
    });

    this.filterDS.getSource().forEach((item: PivotField) => { // filters
      
      confItem = this.model.widgetEngine.newWcio(this.context.fdk, idx);
      // console.log('c item', item.code, item.label, item.format);
      confItem.fdvf = item.code;
      confItem.lbl = item.label;
      // this.model.widgetEngine.wcioStyleParams(confItem,null, null, item.headerStyle); // format & style
      this.context.f.push(confItem);
      idx++;
    });


    this.context.ff = this.widgets.map((obj) => obj.source);
    this.context.shd = this.cbShowDeleteCol.wizChecked; // affichage du delete
    this.context.shs = this.cbShowSelectCol.wizChecked; // affichage du select
  }

  public onHide() {
    if (this.doSaveFlag) {
      if (!!this.updateCallback) {
        this.updateContext();
        this.updateCallback(this.context);
      }
    }
  }

  onWidgetsChanged(event: gridsterItemEvent) {
    // console.log('onWidgetsChanged',event, this.widgets);
    switch(event.action) {
      case EM_ACTION.CREATE:
        this.widgets = [event.item, ...this.widgets];
        break;
      case EM_ACTION.UPDATE:
        // console.log('onWidgetsChanged rien a faire');
        event.item.updateCoords(); // mise à jour des coords
        break;
      case EM_ACTION.DELETE:
        this.widgets.splice(this.widgets.indexOf(event.item), 1);
        break;     
    }
  }

  /**
   * sur drop d'un FeiKeyDef, encapsulation en PivotField avant ajout à la DS
   * @param wbc la liste source
   * @param item l'objet draggé
   * @returns le pivotField
   */
  protected fakeToFF(wbc: WizBaseCollector, item: PivotField): PivotField {
    const wcio: WidgetConfigurationItemObj = this.model.widgetEngine.newWcio(item.contextItem.cod, 0);
    const fake: FreedataArgsVO = item.arg;
    let result: PivotField = null;
    switch (wbc) {
      case this.lstColumn:
        result = new PivotField(this.widget, wcio, null, fake);
        result.usedAsColumn = true;
        break;
      case this.lstRow:
        result = new PivotField(this.widget, wcio, null, fake);
        result.usedAsRow = true;
        break;
      case this.lstFilter:
        result = new PivotField(this.widget, wcio, null, fake);
        result.usedAsFilter = true;
        break;
    }
    return result;
  }

  /* ##############################################################################
                   filtre et rendu de la DS principale
     ############################################################################## */

  /**
   * modification du filtre
   * @param e WizEvent
   */
  protected doFilter(e: WizEvent): void {
    this.dataSource.refresh();
  }

  // filterFunc de la collection principale
  protected filterFunc(item: FeiKeyDef): boolean {
    return this.mainFilter.checkVisible(item);
  }

  /**
   * détection de la position des fields. Alimentation de la donnée sur dataSource (celle du FEI)
   * pour signaler les champs utilisés
   */
  protected checkFieldIsUsed(): void {
    // map pour les 4 collections
    const measureMap: Map<string, PivotField> = new Map(this.measureDS.getSource().map((item) => [item.fdvField, item]));
    const rowMap: Map<string, PivotField> = new Map(this.rowDS.getSource().map((item) => [item.fdvField, item]));

    this.dataSource.getSource().forEach((item:PivotField) => {
      item.usedAsColumn = measureMap.has(item.code);
      item.usedAsRow = rowMap.has(item.code);
    });
    this.dataSource.refresh();
  }

  /* ##############################################################################
                  modification du contenu de l'une des zones
    ############################################################################## */

  /**
   * Modification du modèle
   * @param e Evenement model change
   */
  protected updateModel(e: WizEvent): void {
    this.checkFieldIsUsed(); // synchro du rendu de la liste principale (icone oeil pour Used)
  }

  /**
   * demande d'affichage de la popUp de configuration des champs
   * définition du libellé de la date (1/2) et 
   * @param e alkEvent, data = [pivotField, wizBaseCollector]
   */
  protected showConfPop(e: AlkEvent): void {
    if (PopUpManager.exist(this.fieldPop)) {
      // suppression de l'instance existante
      this.fieldPop.hide();
    }

    // // ouverture de la pop. Data[fei, context, WizbaseCollector, PivotField, callback]
    this.fieldPop = new WizPopUp( FreedataHeaderEditPop, true, false, WIZ_PHYSIC_POSITION.MIDDLE_CENTER,
      FreedataHeaderEditPop.baseWidth + 'px',
      FreedataHeaderEditPop.baseHeight + 'px');

    // construction des données
    const datas: widgetHeaderVO = {
      popReference: this.fieldPop,
      fei: null,
      context: this.context,
      updateCallback: this.backFromFieldPop.bind(this),
      pivotField: e.data[0],
      baseCollector: e.data[1],
      popUpMode: this.popUpMode,
      widget: this.widget
    }

    // // alimentation des datas
    this.fieldPop.datas = datas;

    this.fieldPop.show();
  }

  /** l'élément est actuellement est une date */
  public isDateOrFormula(arg: FreedataArgsVO): boolean {
    // console.log('owner', this.owner);
    let result: boolean = false;
    if(arg.dataType === FIELD_KIND.DATE) {
      result =  true;
    }if(arg.dataType === FIELD_KIND.WORKFLOW) {
      result =  true;
    } else if(arg.dataType === FIELD_KIND.FORMULA){
      result = true;
      // console.log('isDate', arg.format);
    }

    return result; // this.owner.id === 'freeList' && this.data.arg.dataType === FIELD_KIND.DATE; // affichage de l'oeil uniquement dans la liste de choix
  }


  /**
   * retour d'édition de champ
   * @param wbc la collection d'origine, transmise par l'event de showConfPop
   * @param pf PivotField
   */
  protected backFromFieldPop(wbc: WizBaseCollector, pf: PivotField): void {
    wbc.wizDataProvider.refresh();
  }

  /* ##############################################################################
                   contrôles de cohérence du drag'n'drop
     ############################################################################## */

  /** Fonction de controle du drop */
  public measureDropControl({ item, dragSource }: WizDropItemEvent): boolean {
    const field: PivotField = item.data as PivotField;
    if (dragSource === this.lstColumn) {
      // déplacement self dans la liste de filtre
      return true; // on laisse passer
    }

    if (!this.isDateOrFormula(field.arg)) { // uniquement des dates & les workcom
      return false;
    }

    // sinon, contrôle d'unicité du filtre
    // for (const ff of this.measureDS.getSource()) {
    //   if (ff.code === field.code) {
    //     return false;
    //   }
    // }
    return true;
  }

  /** Fonction de controle du drop */
  public filterDropControl({ item, dragSource }: WizDropItemEvent): boolean {
    const field: PivotField = item.data as PivotField;
    if (dragSource === this.lstFilter) {
      // déplacement self dans la liste de filtre
      return true; // on laisse passer
    }

    // sinon, contrôle d'unicité du filtre
    for (const ff of this.filterDS.getSource()) {
      if (ff.code === field.code) {
        return false;
      }
    }
    return true;
  }

}
